import { Roles, User } from "@/models/user.model";
import { useCourseStudentStore } from "@/store/course-student";
import { removeAllStorage } from "@/utils/save-storage.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import jwtDecode from "jwt-decode";

export function guardAuth(to: any, from: any, next: any): void {
  const hasUser = getUserFromStorage();
  const isMeta = "auth" in to.meta;
  const metaAuth = to.meta.auth;
  const isTokenExpired = getUserFromStorage()
    ? checkTokenExpiration(getUserFromStorage().token)
    : null;
  if (isTokenExpired == true || (isMeta && metaAuth && !hasUser)) {
    next("/sign-in");
    removeAllStorage();
  } else if (isMeta && !metaAuth && hasUser) {
    roleType(hasUser, next);
  } else {
    if (to.meta.pageCourseTraditional === null && hasUser.role === "STUDENT") {
      to.meta.pageCourseTraditional = !useCourseStudentStore.getIsAdaptive;
    }
    next();
  }
}

function roleType(user: User, next: any): void {
  if (user?.role == Roles.ADMINISTRATOR) {
    next("/dashboard-admin");
  } else if (user?.role == Roles.STUDENT) {
    next("/dashboard-student");
  } else if (user?.role == Roles.TEACHER) {
    next("/dashboard-teacher");
  } else {
    next("/organizations");
  }
}
function checkTokenExpiration(token): boolean {
  const decodedToken: any = jwtDecode(token);
  let expirationDate;
  if (decodedToken) {
    expirationDate = new Date(decodedToken?.exp * 1000);
  }
  const currentDate = new Date();
  return currentDate > expirationDate;
}
